import { render, staticRenderFns } from "./BookingCostsTable.vue?vue&type=template&id=5e4c208e&scoped=true&lang=pug&"
import script from "./BookingCostsTable.vue?vue&type=script&lang=js&"
export * from "./BookingCostsTable.vue?vue&type=script&lang=js&"
import style0 from "./BookingCostsTable.vue?vue&type=style&index=0&id=5e4c208e&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e4c208e",
  null
  
)

export default component.exports